import React from 'react';

export function AdminPageLayout({ children, className = '' }) {
  return (
    <div className={`space-y-6 ${className}`}>
      {children}
    </div>
  );
}

export default AdminPageLayout;
